import styled from 'styled-components';
import { motion } from 'framer-motion';

const TestimonialsContainer = styled.div`
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--color-white);

  @media (max-width: 768px) {
    height: 1200px;
  }

  @media (max-width: 480) {
    height: 1300px;
  }
`;

const TestimonialsWrapper = styled(motion.div)`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: initial;
  grid-gap: 1.25rem;
  padding: 0 50px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const TestimonialsCard = styled(motion.article)`
  background: var(--color-white);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: var(--box-shadow-big);

  position: relative;

  &::before {
    position: absolute;
    color: #d1d1d1;
    line-height: 1;
    width: 2rem;
    height: 2rem;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', sans-serif;
    font-size: 7.5rem;
    font-weight: 600;
  }

  &::before {
    content: '“';
    top: 1rem;
    left: 1rem;
    // right: 0;
  }

  &:hover {
    cursor: pointer;
  }
`;

const TestimonialsAvatar = styled.img`
  width: 96px;
  height: 96px;
  border: 2px solid #dfdfdf;
  border-radius: 50%;
  margin-bottom: 1rem;

  filter: grayscale(100%);
`;

const TestimonialsHeading = styled.h1`
  font-size: 3rem;
  line-height: 1.1;
  color: var(--color-black);
  font-weight: 600;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const TestimonialsUser = styled.h2`
  font-size: 1.25rem;
  margin-bottom: 10px;
`;

const TestimonialsParagraph = styled.p`
  font-size: 0.9rem;
  text-align: center;
  margin-bottom: 10px;
`;

const TestimonialsStar = styled.span`
  width: 25px;
  height: 25px;
  text-align: center;

  display: flex;
  justify-content: center;
`;

export {
  TestimonialsContainer,
  TestimonialsHeading,
  TestimonialsWrapper,
  TestimonialsCard,
  TestimonialsAvatar,
  TestimonialsParagraph,
  TestimonialsUser,
  TestimonialsStar
};
